/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Plugin Duplicates";
const frontMatter = {};
import {Alert} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <Alert severity="warning"><_components.p>{"This plugin doesn’t support duplicates of itself within the same pipeline."}</_components.p></Alert>;
}

export default MDXLayout